// import { setUserData } from "./user.actions";
import jwtService from "services/jwtService";

export const REGISTER_START = "REGISTER_START";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_ERROR = "REGISTER_ERROR";

export function submitRegister({
  fullname,
  mobile,
  captcha,
  password,
  email,
  onSuccess,
  onError,
}) {
  return (dispatch) => {
    dispatch({
      type: REGISTER_START,
    });
    jwtService
      .createUser({ fullname, mobile, captcha, password, email })
      .then((user) => {
        // dispatch(setUserData(user));
        onSuccess();
        return dispatch({
          type: REGISTER_SUCCESS,
          payload: user,
        });
      })
      .catch((error) => {
        onError();
        return dispatch({
          type: REGISTER_ERROR,
          payload: error,
        });
      });
  };
}
